
angular.module('trainerWebApp.resources').factory('CustomFieldsCtrlResolver',
  ['$q', '$route', 'customFieldsResource', 'Validation', '$location', 'errorHandler', '$rootScope', 'Auth', function ($q, $route, customFieldsResource, Validation, $location, errorHandler, $rootScope, Auth) {

    return function () {
      var deferred = $q.defer();
      var pageName = $route.current.params.pageName || $route.current.pageName;

      var successCb = function (result) {
        Auth.getRolePromise().then(function() {
          deferred.resolve(result);
        });
      };


      // we have to wrap resource into a promise because it returns just a regular object
      function wrapResource(resource, id) {
        var d = $q.defer();
        resource(id, function (result) {
          d.resolve(result);
        }, function (error) {
          // TODO: Better error checking
          if (error && error.data && error.data.error)
            d.reject(error.data.error.stack);
          else
            d.reject("Bad Account ID?");
        });
        return d.promise;
      }

      // let the controller handle the validate
      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      // If redirecting to Flex than quit out before trying to hit gaviota-api for data.
      if(!pageName)
        return;

      if (pageName == 'manageCustomFields') {
        customFieldsResource.getCustomFields(mfConfig.accountId, successCb, errorHandler.defaultServerErrorHandler());
      }

      return deferred.promise;
    };
  }]
);
